import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { cloudServices } from '@store/DevOpsData';

import * as styles from './Cloud.module.scss';

export const Cloud: React.FC = () => {
	return (
		<PaddingContainer id="cloud" className="white-bg">
			<WidthContainer>
				<h2 className="font-size-medium-title">Cloud</h2>
				<p className={classNames(styles.subtitle, 'font-size-sm mt-2')}>
					Servers that are not on the premises of the business using them are
					referred to as being in "the cloud." In a cloud environment,
					management consoles and web interfaces are used to administer and
					configure these servers remotely. Therefore, even if their "owners"
					cannot reach the servers physically, they can still be accessed and
					managed remotely.
				</p>
				<div
					className={classNames(
						styles.cloudServices,
						'd-flex flex-column flex-md-row mt-5'
					)}
				>
					{cloudServices.map((service) => (
						<div
							className={classNames(styles.service, 'font-size-md font-600')}
							key={service.title}
						>
							<img src={service.icon} alt={service.title} />
							<div className="mt-4">
								<p>{service.title}</p>
								<p>{service.subtitle}</p>
								<p className="font-size-sm line-height-26 font-400 mt-2">
									{service.description}
								</p>
							</div>
						</div>
					))}
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
